import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsStatus } from '../../fragments/generated/ProjectNotificationsStatus';
import { ProjectNotificationsOverrideStatus } from '../../fragments/generated/ProjectNotificationsOverrideStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DisableProjectNotificationsMutationVariables = Types.Exact<{
  input: Types.ToggleProjectNotificationsInput;
}>;


export type DisableProjectNotificationsMutation = { __typename?: 'Mutation', disableProjectNotifications?: { __typename?: 'ToggleProjectNotificationsPayload', project?: { __typename?: 'Project', id: string, notificationsEnabled?: boolean | null, hasProjectNotificationsOverride?: boolean | null } | null } | null };


export const DisableProjectNotifications = /*#__PURE__*/ gql`
    mutation DisableProjectNotifications($input: ToggleProjectNotificationsInput!) {
  disableProjectNotifications(input: $input) {
    project {
      ...ProjectNotificationsStatus
      ...ProjectNotificationsOverrideStatus
    }
  }
}
    ${ProjectNotificationsStatus}
${ProjectNotificationsOverrideStatus}` as unknown as DocumentNode<DisableProjectNotificationsMutation, DisableProjectNotificationsMutationVariables>;

          

          export const useDisableProjectNotificationsMutation = (options?:MutationHookOptions<DisableProjectNotificationsMutation, DisableProjectNotificationsMutationVariables>) => useMutation(DisableProjectNotifications, options);
          

          export type DisableProjectNotificationsMutationOptions = MutationHookOptions<DisableProjectNotificationsMutation, DisableProjectNotificationsMutationVariables>;

          

          export type DisableProjectNotificationsMutationResult = ReturnType<typeof useDisableProjectNotificationsMutation>[1];

          
